import './../styles/buildViewer.scss';
import React from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Row,
  PanelGroup
} from 'react-bootstrap';

import BuildInfoComponent from './BuildInfoComponent';
import DispatcherBuildGaugeContainer from './../Containers/DispatcherBuildGaugeContainer';
import MetricsBuildGaugeContainer from './../Containers/MetricsBuildGaugeContainer';
import BuildMetricsContainer from './../Containers/BuildMetricsContainer';
import InstallerTableWrapperContainer from
  './../Containers/InstallerTableWrapperContainer';
import ArtifactHitCountModalContainer from
  './../Containers/ArtifactHitCountModalContainer';
import JiraConfirmModalContainer from './../Containers/JiraConfirmModalContainer';
import StatisticsModalContainer from './../Containers/StatisticsModalContainer';
import BuildSelectorModalContainer from './../Containers/BuildSelectorModalContainer';
import { DispatcherTypes, build as buildConstants } from './../helpers';

const BuildViewerComponent = ({
  builds,
  baselineBuilds,
  baselineBuildType,
  onShowBaselineSelectorModal
}) => (
  <div>
    <div className="side-nav">
      <ArtifactHitCountModalContainer />
      <JiraConfirmModalContainer />
      <StatisticsModalContainer />
      <BuildSelectorModalContainer />

      <Row>
        <Col md={10} mdOffset={2}>
          <BuildInfoComponent
            builds={builds}
            baselines={baselineBuilds}
            isExpectedBaseline={baselineBuildType === buildConstants.EXPECTED}
            isLatestByImage={baselineBuildType === buildConstants.LATEST_BY_IMAGE}
          />
        </Col>
      </Row>
      <Row>
        <Col md={10} mdOffset={2}>
          <a onClick={onShowBaselineSelectorModal}>Select Baseline</a>
        </Col>
      </Row>
    </div>
    <Row className="padded">
      <DispatcherBuildGaugeContainer
        type={DispatcherTypes.Artifact}
        title="Artifact Regression"
        endPoint="artifact-regression"
      />
      <DispatcherBuildGaugeContainer
        type={DispatcherTypes.White}
        title="White Tests"
        endPoint="white"
      />
      <DispatcherBuildGaugeContainer
        type={DispatcherTypes.Export}
        title="Export Tests"
        endPoint="export-regression"
      />
      <MetricsBuildGaugeContainer />
    </Row>
    <hr />
    <Row>
      <PanelGroup id="build-metrics">
        <Row>
          <Col md={12}>
            <BuildMetricsContainer />
          </Col>
        </Row>
      </PanelGroup>
    </Row>
    <Row>
      <PanelGroup id="installer-table-wrapper">
        <Row>
          <Col md={12}>
            <InstallerTableWrapperContainer />
          </Col>
        </Row>
      </PanelGroup>
    </Row>
  </div>
);

BuildViewerComponent.propTypes = {
  builds: PropTypes.array.isRequired,
  baselineBuilds: PropTypes.array.isRequired,
  baselineBuildType: PropTypes.string.isRequired,
  onShowBaselineSelectorModal: PropTypes.func.isRequired
};

export default BuildViewerComponent;


// WEBPACK FOOTER //
// src/Components/BuildViewerComponent.jsx